//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

import { ClientBase } from "../ClientBase";

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class SearchClient extends ClientBase {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  commonSearchSearch(body: SearchRequest | undefined): Promise<SearchResponse> {
    let url_ = this.baseUrl + "/v1/CommonSearch";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCommonSearchSearch(_response);
      });
  }

  protected processCommonSearchSearch(response: Response): Promise<SearchResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SearchResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<SearchResponse>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  dynamicLinqSearch(body: DynamicLinqRequest | undefined): Promise<SearchResponse> {
    let url_ = this.baseUrl + "/v1/DynamicLinq";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDynamicLinqSearch(_response);
      });
  }

  protected processDynamicLinqSearch(response: Response): Promise<SearchResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SearchResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<SearchResponse>(null as any);
  }
}

export class DynamicLinqItem implements IDynamicLinqItem {
  operator?: string | undefined;
  expression?: string | undefined;
  parameters?: Parameter[] | undefined;

  constructor(data?: IDynamicLinqItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.operator = _data["operator"];
      this.expression = _data["expression"];
      if (Array.isArray(_data["parameters"])) {
        this.parameters = [] as any;
        for (let item of _data["parameters"]) this.parameters!.push(Parameter.fromJS(item));
      }
    }
  }

  static fromJS(data: any): DynamicLinqItem {
    data = typeof data === "object" ? data : {};
    let result = new DynamicLinqItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["operator"] = this.operator;
    data["expression"] = this.expression;
    if (Array.isArray(this.parameters)) {
      data["parameters"] = [];
      for (let item of this.parameters) data["parameters"].push(item.toJSON());
    }
    return data;
  }
}

export interface IDynamicLinqItem {
  operator?: string | undefined;
  expression?: string | undefined;
  parameters?: Parameter[] | undefined;
}

export class DynamicLinqRequest implements IDynamicLinqRequest {
  pageing?: Pageing;
  parameters?: { [key: string]: Parameter } | undefined;
  dynamicLinqItems?: DynamicLinqItem[] | undefined;
  dynamicLinqString?: string | undefined;

  constructor(data?: IDynamicLinqRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.pageing = _data["pageing"] ? Pageing.fromJS(_data["pageing"]) : <any>undefined;
      if (_data["parameters"]) {
        this.parameters = {} as any;
        for (let key in _data["parameters"]) {
          if (_data["parameters"].hasOwnProperty(key))
            (<any>this.parameters)![key] = _data["parameters"][key]
              ? Parameter.fromJS(_data["parameters"][key])
              : new Parameter();
        }
      }
      if (Array.isArray(_data["dynamicLinqItems"])) {
        this.dynamicLinqItems = [] as any;
        for (let item of _data["dynamicLinqItems"]) this.dynamicLinqItems!.push(DynamicLinqItem.fromJS(item));
      }
      this.dynamicLinqString = _data["dynamicLinqString"];
    }
  }

  static fromJS(data: any): DynamicLinqRequest {
    data = typeof data === "object" ? data : {};
    let result = new DynamicLinqRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["pageing"] = this.pageing ? this.pageing.toJSON() : <any>undefined;
    if (this.parameters) {
      data["parameters"] = {};
      for (let key in this.parameters) {
        if (this.parameters.hasOwnProperty(key))
          (<any>data["parameters"])[key] = this.parameters[key] ? this.parameters[key].toJSON() : <any>undefined;
      }
    }
    if (Array.isArray(this.dynamicLinqItems)) {
      data["dynamicLinqItems"] = [];
      for (let item of this.dynamicLinqItems) data["dynamicLinqItems"].push(item.toJSON());
    }
    data["dynamicLinqString"] = this.dynamicLinqString;
    return data;
  }
}

export interface IDynamicLinqRequest {
  pageing?: Pageing;
  parameters?: { [key: string]: Parameter } | undefined;
  dynamicLinqItems?: DynamicLinqItem[] | undefined;
  dynamicLinqString?: string | undefined;
}

export class Pageing implements IPageing {
  skip?: number;
  take?: number;
  calcPages?: boolean;
  postSorting?: PostSorting;

  constructor(data?: IPageing) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.skip = _data["skip"];
      this.take = _data["take"];
      this.calcPages = _data["calcPages"];
      this.postSorting = _data["postSorting"] ? PostSorting.fromJS(_data["postSorting"]) : <any>undefined;
    }
  }

  static fromJS(data: any): Pageing {
    data = typeof data === "object" ? data : {};
    let result = new Pageing();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["skip"] = this.skip;
    data["take"] = this.take;
    data["calcPages"] = this.calcPages;
    data["postSorting"] = this.postSorting ? this.postSorting.toJSON() : <any>undefined;
    return data;
  }
}

export interface IPageing {
  skip?: number;
  take?: number;
  calcPages?: boolean;
  postSorting?: PostSorting;
}

export class Parameter implements IParameter {
  dynamicValue?: any | undefined;
  stringValue?: string | undefined;
  intValue?: number | undefined;
  boolValue?: boolean | undefined;
  dateTimeValue?: Date | undefined;
  doubleValue?: number | undefined;
  floatValue?: number | undefined;
  decimalValue?: number | undefined;
  longValue?: number | undefined;
  shortValue?: number | undefined;
  byteValue?: number | undefined;
  charValue?: string | undefined;
  guidValue?: string | undefined;
  intValues?: number[] | undefined;
  stringValues?: string[] | undefined;
  guidValues?: string[] | undefined;
  readonly value?: any | undefined;

  constructor(data?: IParameter) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dynamicValue = _data["dynamicValue"];
      this.stringValue = _data["stringValue"];
      this.intValue = _data["intValue"];
      this.boolValue = _data["boolValue"];
      this.dateTimeValue = _data["dateTimeValue"] ? new Date(_data["dateTimeValue"].toString()) : <any>undefined;
      this.doubleValue = _data["doubleValue"];
      this.floatValue = _data["floatValue"];
      this.decimalValue = _data["decimalValue"];
      this.longValue = _data["longValue"];
      this.shortValue = _data["shortValue"];
      this.byteValue = _data["byteValue"];
      this.charValue = _data["charValue"];
      this.guidValue = _data["guidValue"];
      if (Array.isArray(_data["intValues"])) {
        this.intValues = [] as any;
        for (let item of _data["intValues"]) this.intValues!.push(item);
      }
      if (Array.isArray(_data["stringValues"])) {
        this.stringValues = [] as any;
        for (let item of _data["stringValues"]) this.stringValues!.push(item);
      }
      if (Array.isArray(_data["guidValues"])) {
        this.guidValues = [] as any;
        for (let item of _data["guidValues"]) this.guidValues!.push(item);
      }
      (<any>this).value = _data["value"];
    }
  }

  static fromJS(data: any): Parameter {
    data = typeof data === "object" ? data : {};
    let result = new Parameter();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["dynamicValue"] = this.dynamicValue;
    data["stringValue"] = this.stringValue;
    data["intValue"] = this.intValue;
    data["boolValue"] = this.boolValue;
    data["dateTimeValue"] = this.dateTimeValue ? this.dateTimeValue.toISOString() : <any>undefined;
    data["doubleValue"] = this.doubleValue;
    data["floatValue"] = this.floatValue;
    data["decimalValue"] = this.decimalValue;
    data["longValue"] = this.longValue;
    data["shortValue"] = this.shortValue;
    data["byteValue"] = this.byteValue;
    data["charValue"] = this.charValue;
    data["guidValue"] = this.guidValue;
    if (Array.isArray(this.intValues)) {
      data["intValues"] = [];
      for (let item of this.intValues) data["intValues"].push(item);
    }
    if (Array.isArray(this.stringValues)) {
      data["stringValues"] = [];
      for (let item of this.stringValues) data["stringValues"].push(item);
    }
    if (Array.isArray(this.guidValues)) {
      data["guidValues"] = [];
      for (let item of this.guidValues) data["guidValues"].push(item);
    }
    data["value"] = this.value;
    return data;
  }
}

export interface IParameter {
  dynamicValue?: any | undefined;
  stringValue?: string | undefined;
  intValue?: number | undefined;
  boolValue?: boolean | undefined;
  dateTimeValue?: Date | undefined;
  doubleValue?: number | undefined;
  floatValue?: number | undefined;
  decimalValue?: number | undefined;
  longValue?: number | undefined;
  shortValue?: number | undefined;
  byteValue?: number | undefined;
  charValue?: string | undefined;
  guidValue?: string | undefined;
  intValues?: number[] | undefined;
  stringValues?: string[] | undefined;
  guidValues?: string[] | undefined;
  value?: any | undefined;
}

export class PostSorting implements IPostSorting {
  fieldName?: string | undefined;
  intValues?: number[] | undefined;
  stringValues?: string[] | undefined;
  guidValues?: string[] | undefined;
  readonly values?: any | undefined;

  constructor(data?: IPostSorting) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fieldName = _data["fieldName"];
      if (Array.isArray(_data["intValues"])) {
        this.intValues = [] as any;
        for (let item of _data["intValues"]) this.intValues!.push(item);
      }
      if (Array.isArray(_data["stringValues"])) {
        this.stringValues = [] as any;
        for (let item of _data["stringValues"]) this.stringValues!.push(item);
      }
      if (Array.isArray(_data["guidValues"])) {
        this.guidValues = [] as any;
        for (let item of _data["guidValues"]) this.guidValues!.push(item);
      }
      (<any>this).values = _data["values"];
    }
  }

  static fromJS(data: any): PostSorting {
    data = typeof data === "object" ? data : {};
    let result = new PostSorting();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["fieldName"] = this.fieldName;
    if (Array.isArray(this.intValues)) {
      data["intValues"] = [];
      for (let item of this.intValues) data["intValues"].push(item);
    }
    if (Array.isArray(this.stringValues)) {
      data["stringValues"] = [];
      for (let item of this.stringValues) data["stringValues"].push(item);
    }
    if (Array.isArray(this.guidValues)) {
      data["guidValues"] = [];
      for (let item of this.guidValues) data["guidValues"].push(item);
    }
    data["values"] = this.values;
    return data;
  }
}

export interface IPostSorting {
  fieldName?: string | undefined;
  intValues?: number[] | undefined;
  stringValues?: string[] | undefined;
  guidValues?: string[] | undefined;
  values?: any | undefined;
}

export class SearchFilter implements ISearchFilter {
  preCondition?: string | undefined;
  selection?: string | undefined;
  postCondition?: string | undefined;
  orderBy?: string | undefined;

  constructor(data?: ISearchFilter) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.preCondition = _data["preCondition"];
      this.selection = _data["selection"];
      this.postCondition = _data["postCondition"];
      this.orderBy = _data["orderBy"];
    }
  }

  static fromJS(data: any): SearchFilter {
    data = typeof data === "object" ? data : {};
    let result = new SearchFilter();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["preCondition"] = this.preCondition;
    data["selection"] = this.selection;
    data["postCondition"] = this.postCondition;
    data["orderBy"] = this.orderBy;
    return data;
  }
}

export interface ISearchFilter {
  preCondition?: string | undefined;
  selection?: string | undefined;
  postCondition?: string | undefined;
  orderBy?: string | undefined;
}

export class SearchRequest implements ISearchRequest {
  pageing?: Pageing;
  filter?: SearchFilter;

  constructor(data?: ISearchRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.pageing = _data["pageing"] ? Pageing.fromJS(_data["pageing"]) : <any>undefined;
      this.filter = _data["filter"] ? SearchFilter.fromJS(_data["filter"]) : <any>undefined;
    }
  }

  static fromJS(data: any): SearchRequest {
    data = typeof data === "object" ? data : {};
    let result = new SearchRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["pageing"] = this.pageing ? this.pageing.toJSON() : <any>undefined;
    data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
    return data;
  }
}

export interface ISearchRequest {
  pageing?: Pageing;
  filter?: SearchFilter;
}

export class SearchResponse implements ISearchResponse {
  totalNoOfRows?: number;
  rows?: any[] | undefined;

  constructor(data?: ISearchResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalNoOfRows = _data["totalNoOfRows"];
      if (Array.isArray(_data["rows"])) {
        this.rows = [] as any;
        for (let item of _data["rows"]) this.rows!.push(item);
      }
    }
  }

  static fromJS(data: any): SearchResponse {
    data = typeof data === "object" ? data : {};
    let result = new SearchResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["totalNoOfRows"] = this.totalNoOfRows;
    if (Array.isArray(this.rows)) {
      data["rows"] = [];
      for (let item of this.rows) data["rows"].push(item);
    }
    return data;
  }
}

export interface ISearchResponse {
  totalNoOfRows?: number;
  rows?: any[] | undefined;
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}
